import localStorage from 'local-storage'

localStorage.set('flashService.data', {})
const state = localStorage.get('flashService.data');

const flashService = {
  state: state,
  add: function(key,msg) {
    this.state[key] = msg;
    localStorage.set('flashService.data', this.state);
  },
  get: function(key) {
    const msg = this.state[key];
    if (msg) {
      delete this.state[key];
      localStorage.set('flashService.data', this.state);
      return msg;
    }
    return 0;
  }
}

export default flashService



// WEBPACK FOOTER //
// ./src/service/flashService.js